import { useRouter } from 'next/router'
import { useState } from 'react'
import Image from 'next/legacy/image'
import Pagination from './Pagination'
import Loader from '../../newLoader/Loader'
import Button from '../../newButton/Button'
import styles from './vetsResult.module.scss'
import useMediaQuery from '../../../utils/publicApi'

const Card = ({ data, isMobile }) => {
  const {
    name: title,
    location,
    rating,
    review_count: reviews,
    is_closed: closed,
    phone,
    image_url: src,
    url: web
  } = data
  const numberRate = rating
  const { zip_code: zipCode, address1, city, state } = location
  const locations = `${zipCode} ${address1}, ${city}, ${state}`
  const stars = (numberRate) => {
    const ratingArr = [1, 1, 1, 1, 1].fill(0, numberRate)

    if (!Number.isInteger(Number(numberRate))) {
      const isCero = (element) => element < 1
      const index = ratingArr.findIndex(isCero)
      return (
        <>
          {ratingArr.map((rating, i) =>
            i === index
              ? (
                <img
                  key={i}
                  alt='half star icon'
                  style={{ width: '22px ', marginTop: '3px' }}
                  src='/vets/vets-data/star-half.svg'
                />
                )
              : rating
                ? (
                  <img
                    key={i}
                    alt='yellow star icon'
                    src='/vets/vets-data/star-yellow.svg'
                  />
                  )
                : (
                  <img
                    key={i}
                    alt='gray star icon'
                    src='/vets/vets-data/star-gray.svg'
                  />
                  )
          )}
        </>
      )
    } else {
      return (
        <>
          {ratingArr.map((rating, i) =>
            rating
              ? (
                <img
                  key={i}
                  alt='yellow star icon'
                  src='/vets/vets-data/star-yellow.svg'
                />
                )
              : (
                <img
                  key={i}
                  alt='gray star icon'
                  src='/vets/vets-data/star-gray.svg'
                />
                )
          )}
        </>
      )
    }
  }

  return (
    <div className={styles.cardContainer}>
      <section className={styles.imageDesktop}>
        <Image
          src={src.length > 0 ? src : '/vets/placeholder-vets.svg'}
          alt=''
          quality={75}
          layout='responsive'
          width={250}
          height={180}
          objectFit='cover'
          priority
        />
      </section>
      <section className={styles.imageMobile}>
        <Image
          src={src.length > 0 ? src : '/vets/placeholder-vets.svg'}
          alt=''
          quality={75}
          layout='responsive'
          width={250}
          height={90}
          objectFit='cover'
          priority
        />
      </section>
      <section className={styles.info}>
        <div className={styles.title}>
          <div>
            {isMobile
              ? title.length > 30
                ? title.slice(0, 30) + '...'
                : title
              : title}
          </div>
        </div>
        <div className={styles.range}>
          {stars(numberRate)}{' '}
          <span>
            {rating} out of {reviews} reviews
          </span>
        </div>
        <div className={styles.extraData}>
          <div className={styles.section}>
            <img
              src='/vets/vets-data/clock.svg'
              alt='clock icon'
              className={styles.icon}
            />
            <div className={styles.text}>{closed ? 'Close' : 'Open Now'}</div>
          </div>
          {phone && (
            <a
              className={styles.section}
              href={`tel:${phone}`}
              onClick={() => {
                // GTM call
                if (window.dataLayer) {
                  window.dataLayer.push({ event: 'call' })
                }
                // UA call
                if (window.ga?.getAll) {
                  window.ga.getAll()[0].send('event', 'call')
                }
              }}
            >
              <img
                src='/vets/vets-data/phone.svg'
                alt='phone icon'
                className={styles.icon}
              />
              <div className={styles.text}>{phone}</div>
            </a>
          )}
          <div className={styles.section}>
            <img
              src='/vets/vets-data/map-pin.svg'
              alt='search icon'
              className={styles.icon}
            />
            <div className={styles.text}>
              {locations.length > 35
                ? locations.slice(0, 35) + '...'
                : locations}
            </div>
          </div>
          {web && (
            <div className={styles.section}>
              <img
                src='/vets/vets-data/website.svg'
                alt='global icon'
                className={styles.icon}
              />
              <a className={styles.link} href={web}>
                More details
              </a>
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default function VetsResult ({ city, state, vetsData, loading }) {
  const router = useRouter()
  const isMobile = useMediaQuery('(max-width:600px)')
  // Pagination
  const [currentPage, setCurrentPage] = useState(1)
  const vetsPerPage = 4
  const numberOfLastVets = currentPage * vetsPerPage
  const numberOfFirstVet = numberOfLastVets - vetsPerPage
  const currentVets = vetsData?.slice(numberOfFirstVet, numberOfLastVets)
  const totalPages = Math.ceil(vetsData?.length / vetsPerPage)

  return (
    <div className={styles.article}>
      {loading
        ? (
          <div className={styles.loader}>
            {' '}
            <Loader theme='tall' />
          </div>
          )
        : vetsData?.length > 0
          ? (
            <div className={styles.dataSection}>
              {currentVets.map((vet) => {
                return (
                  <div key={vet.id}>
                    <Card data={vet} isMobile={isMobile} />
                  </div>
                )
              })}
              {vetsData.length < 5
                ? (
                  <section className={styles.returnState}>
                    <p className={styles.text}>
                      There are currently no more veterinarians listed in {city},{' '}
                      {state}.
                    </p>
                    <Button
                      title='Go back to state'
                      theme={['large', 'pink-solid']}
                      onClick={() => router.push(`/find-a-vet/${state}`)}
                    />
                  </section>
                  )
                : (
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages}
                  />
                  )}
            </div>
            )
          : (
            <div className={styles.returnState}>
              <p className={styles.text}>
                We are sorry. We couldn’t find any matches to your current selection
                in {city}, {state}.{' '}
              </p>
              <Button
                title='Go back to state'
                theme={['large', 'pink-solid']}
                onClick={() => router.push(`/find-a-vet/${state}`)}
              />
            </div>
            )}
    </div>
  )
}
